<template>
  <div class="page_bgQRcodeList">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname" style="width:68px">项目名称:</div>
            <el-select v-model="listQuery.projectId" value-key="Projectid" clearable filterable size="small" placeholder="" @change="searchHandle">
              <el-option v-for="item in proNameList" :key="item.Projectid" :label="item.StrprojectName" :value="item.Projectid">
              </el-option>
            </el-select>
            <el-button type="success" size="small" icon="el-icon-search" @click="searchHandle" style="margin-left:24px">&nbsp;搜索</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-con" v-loading="qrcodeLoading" element-loading-text="生成二维码中" element-loading-spinner="el-icon-loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>小杰闪查</el-breadcrumb-item>
          <el-breadcrumb-item>闪查项目</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="闪查项目" name="first"></el-tab-pane>
          <el-tab-pane label="闪查报告" name="second"></el-tab-pane>
          <el-tab-pane label="闪查二维码" name="third"></el-tab-pane>
        </el-tabs>

        <el-table :data="tableData" border class="doc_table" v-loading="loading">
          <el-table-column prop="ProjectName" label="项目名称" :show-overflow-tooltip="true" align="center" width="130px">
          </el-table-column>
          <el-table-column prop="Name" label="套餐名称" :show-overflow-tooltip="true" align="center" width="160px">
          </el-table-column>
          <el-table-column prop="CustomeName" label="签约二维码" align="center" min-width="160">
            <template slot-scope={row}>
              <div class="flex aic" style="width: 100%;justify-content: center;">
                <img src="./../../assets/images/qrcode.png" class="qrcode_img02" />
                <div class="greenName cp" style="margin-left: 5px;" @click="getNewQRcode(row)" v-if="row.IsStop">生成新码</div>
                <div class="greenName cp" style="margin-left: 5px;" @click="seeQRcode(row)" v-if="!row.IsStop && row.ImageUrl">查看二维码</div>
                <div class="greenName cp" v-if="!row.IsStop" style="margin-left: 15px;" @click="stopUse(row)">停用</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="UseCount" label="二维码次数限制/已使用次数" align="center" min-width="200px">
            <template slot-scope={row}>
              <el-popover placement="top-start" width="550" trigger="click">
                <el-table :data="appTable" v-loading="gridloading" style="width:521px">
                  <el-table-column width="100" property="PersonName" label="姓名"></el-table-column>
                  <el-table-column width="110" property="Tel" label="手机号"></el-table-column>
                  <el-table-column width="200" property="IdCart" label="身份证"></el-table-column>
                  <el-table-column width="100" property="BlankCart" label="银行卡"></el-table-column>
                </el-table>
                <div class="block">
                  <el-pagination v-if="appTotal>0" @current-change="currentChange2" :current-page.sync="appQuery.pageNum" :page-size="Number(appQuery.pageSize)" layout="total,sizes,prev,pager, next, jumper" :total="appTotal"></el-pagination>
                </div>
                <span class="greenName cp" slot="reference" @click="getAppList(row)" v-show="row.UseCount" title="点击查看报名列表">{{row.UseCount + ' / ' + row.UsedCount}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="BuildTime" label="二维码生成时间" :show-overflow-tooltip="true" align="center" width="150">
            <template slot-scope={row}>
              {{ row.BuildTime ? row.BuildTime.replace('T',' ') : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="LoseTime" label="二维码失效时间" :show-overflow-tooltip="true" align="center" width="150">
            <template slot-scope={row}>
              {{ row.LoseTime ? row.LoseTime=='2099/12/31 0:00:00' ? '永久有效' : row.LoseTime.substring(0, 10) : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="CustomeName" label="操作" align="center" width="180px" fixed="right">
            <template slot-scope={row}>
              <span class="greenName cp" @click="toReport(row)">查看报告</span>
              <el-popconfirm title="确定删除吗？" @confirm="del(row)">
                <span slot="reference" class="greenName cp" style="margin-left: 10px;">删除</span>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>


    <el-dialog :visible.sync="showQRcode" width="531px">
      <div class="QRcodeCreateTime" v-if="QRcodeCreateTime">二维码生成时间：{{QRcodeCreateTime.replace('T',' ')}}</div>
      <el-image style="width: 500px;height: 500px;" :src=" headPath + QRCodeSrc" alt=""></el-image>
    </el-dialog>

    <el-dialog :visible.sync="showCreateQRcode" width="450px" title="重新生成二维码">
      <el-form ref="QRform" :model="QRform" :rules="QRrule" label-width="100px">
        <el-form-item label="项目名称">
          <el-input v-model="proName" style="width:220px" size="small" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="使用次数" prop="UseCount">
          <el-input type="number" v-model="QRform.UseCount" style="width:220px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="失效时间" prop="TakeEffectTime">
          <el-date-picker v-model="QRform.TakeEffectTime" type="datetime" placeholder="选择日期时间" default-time="24:00:00">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间" prop="LoseTime">
          <el-date-picker v-model="QRform.LoseTime" type="datetime" placeholder="选择日期时间" default-time="24:00:00">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="showCreateQRcode = false">取 消</el-button>
        <el-button size="small" type="primary" :loading="isLoading" @click="confirmCreateQRcode">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: 0,
        totalCount: 0,
        tableData: [],
        loading: false,
        listQuery: {
          projectId: '',
          BusiType: 2, //2内部 1外部
          pageNum: 1,
          pageSize: 10
        },
        roletype: localStorage.loginRoletype,
        QRCodeSrc: '', //二维码url
        qrcodeLoading: false,
        headPath: this.$store.state.EMP.imgPath,
        showQRcode: false, //二维码弹窗
        QRcodeCreateTime: '', //二维码创建时间
        appTable: [],
        appTotal: 0,
        gridloading: false,
        isLoading: false,
        activeName: 'third',
        proNameList: [],
        QRform: {
          Id: '',
          UseCount: '', //使用次数
          TakeEffectTime: '', //生效时间
          LoseTime: '', //失效时间
        },
        proName: '',
        showCreateQRcode: false,
        QRrule: {
          UseCount: {
            required: true,
            message: "请输入使用次数",
            trigger: "blur",
          },
          LoseTime: {
            required: true,
            message: "请选择失效时间",
            trigger: "blur",
          },
        }
      };
    },
    created() {
      this.calHeight();
      if (this.$route.query.projectId != undefined && this.$route.query.projectId) {
        this.listQuery.projectId = Number(this.$route.query.projectId);
      }
      this.getProList();
      this.GetQrCode();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/assignTemplate',
          powerEnName: 'employee'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      handleClick() {
        if (this.activeName == "first") {
          this.$router.push({
            path: "/backgroundCheck",
          });
        } else if (this.activeName == "second") {
          this.$router.push({
            path: "/backgroundCheckRecord",
            query: {
              BusiId: this.listQuery.projectId,
            },
          });
        }
      },
      searchHandle() {
        this.GetQrCode()
      },
      //获取二维码列表
      GetQrCode() {
        xz.GetQrCode(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data;
            this.totalCount = res.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.$message.error('获取二维码列表失败')
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.GetQrCode();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.GetQrCode();
      },
      //删除
      del(row) {
        xz.DeleteQrCode({
          Id: row.Id
        }).then(res => {
          if (res.status == 'ok') {
            this.$message.success('删除成功！')
            this.GetQrCode()
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //选择项目
      changePro(val) {
        this.formData.ProjectId = val.Projectid;
        this.formData.ProjectName = val.StrprojectName;
      },
      //确认认领
      confirmAssign() {
        this.$refs.assignForm.validate((valid) => {
          if (valid) {
            console.log(this.Temp)
            this.Temp.forEach((element, index) => {
              if (index == 0) {
                this.formData.TempId = element.templateId;
                this.formData.TempName = element.templateName;
              } else {
                this.formData.TempId = this.formData.TempId + ',' + element.templateId;
                this.formData.TempName = this.formData.TempName + ',' + element.templateName;
              }
            });
            xz.updataContractTemp(this.formData, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('认领成功');
                this.GetQrCode()
              } else {
                this.$message.error('系统出错');
              }
              this.showAssign = false;
            })
          }
        })
      },
      //查看二维码
      seeQRcode(row) {
        this.QRcodeCreateTime = row.BuildTime;
        this.QRCodeSrc = row.ImageUrl;
        this.showQRcode = true;
      },
      //停止使用
      stopUse(row) {
        xz.StopQrCode({
          Id: row.Id
        }).then(res => {
          if (res.status == 'ok') {
            this.$message.success('停用成功！')
            this.GetQrCode();
          } else {
            this.$message.error('系统出错');
          }
        })
      },
      //获取二维码报名列表
      getAppList(row) {
        this.appTable = [];
        // this.appTotal = 0;
        this.QueryRecord(row.Id)
      },
      QueryRecord(id) {
        this.gridloading = true;
        let data = {
          Id: id
        }
        xz.QueryRecord(data).then(res => {
          if (res.status == 'ok') {
            this.appTable = res.data;
            this.gridloading = false;
          } else {
            this.appTable = [];
            // this.appTotal = 0;
            this.gridloading = false;
          }
        })
      },
      currentChange2(val) {
        this.appQuery.pageNum = Number(val);
        this.econQRCodeRegisList();
      },
      //限制input输入类型
      limitInput(val, type, item) {
        if (val >= 10000) {
          this.$message.warning(type + '不能超过1万');
          this.$nextTick(() => {
            this.formQR[item] = undefined
          })
        }
      },
      getNewQRcode(row) {
        this.QRform.Id = row.Id;
        this.proName = row.ProjectName;
        this.showCreateQRcode = true;
      },
      //确认创建二维码
      confirmCreateQRcode() {
        this.$refs.QRform.validate((valid) => {
          if (valid) {
            this.isLoading = true;
            xz.ReCreateQrCode(this.QRform).then(res => {
              if (res.status == 'ok') {
                this.showCreateQRcode = false;
                this.isLoading = false;
                this.GetQrCode()
              } else {
                this.$message.error(res.msg)
                this.showCreateQRcode = false;
                this.isLoading = false;
                this.GetQrCode();
              }
            })
          }
        })
      },
      toReport(row) {
        this.$router.push({
          path: "/backgroundCheckRecord",
          query: {
            BusiId: this.listQuery.projectId,
            Id:row.Id
          },
        });
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .qrcode_img02 {
    width: 20px;
    height: 20px;
  }

  .addNewTemp {
    line-height: 32px;
    margin-left: 30px;
    color: #598DE7;
  }

  .QRcodeCreateTime {
    font-size: 18px;
    text-align: center;
  }
</style>
<style>
  .page_bgQRcodeList .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_bgQRcodeList .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_bgQRcodeList .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_bgQRcodeList .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_bgQRcodeList .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_bgQRcodeList .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_bgQRcodeList .screenInputs .screenInput .el-select .el-input__inner,
  .page_bgQRcodeList .re_down_form.el-form--inline .el-form-item__content,
  .page_bgQRcodeList .re_down_form .el-select,
  .page_bgQRcodeList .re_down_form .el-form-item__content,
  .page_bgQRcodeList .screenInput .el-input {
    width: 200px !important;
  }

  .page_bgQRcodeList .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_bgQRcodeList .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_bgQRcodeList .qrForm .el-input-number__increase,
  .page_bgQRcodeList .qrForm .el-input-number__decrease {
    display: none;
  }

  .page_bgQRcodeList .qrForm .el-input-number .el-input__inner {
    padding-left: 15px;
    padding-right: 15px;
    text-align: left;
  }

  .page_bgQRcodeList .qrForm .el-input-number {
    width: 200px;
  }

  .page_bgQRcodeList .qrForm .el-input__icon {
    height: 32px;
  }

  .page_bgQRcodeList .qrForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_bgQRcodeList .qrForm .el-form-item__error {
    top: 34px;
  }
</style>